import { render, staticRenderFns } from "./DotFadeSpinner.vue?vue&type=template&id=756ee3ba&scoped=true"
import script from "./DotFadeSpinner.vue?vue&type=script&lang=js"
export * from "./DotFadeSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756ee3ba",
  null
  
)

export default component.exports